import { z } from 'zod/v4';
import { BackupSettingsSchema } from './schemas/settingsSchemas.js';
export const LogLevelsSchema = z.union([
    z.literal('silent'),
    z.literal('fatal'),
    z.literal('error'),
    z.literal('warn'),
    z.literal('info'),
    z.literal('http'),
    z.literal('debug'),
    z.literal('trace'),
]);
export const LogLevels = [
    'silent',
    'fatal',
    'error',
    'warn',
    'info',
    'http',
    'debug',
    'trace',
];
export const LoggingSettingsSchema = z.object({
    logLevel: LogLevelsSchema,
    logsDirectory: z.string(),
    useEnvVarLevel: z.boolean().default(true),
});
export const CacheSettingsSchema = z.object({
    // Preserve previous behavior
    enablePlexRequestCache: z.boolean().optional().default(false).catch(false),
});
export const ServerSettingsSchema = z.object({
    port: z.number().min(1).max(65535).optional().default(8000),
});
export const DefaultServerSettings = {
    port: 8000,
};
export const SystemSettingsSchema = z.object({
    backup: BackupSettingsSchema,
    logging: LoggingSettingsSchema,
    cache: CacheSettingsSchema.optional(),
    server: ServerSettingsSchema.default(DefaultServerSettings),
});
//# sourceMappingURL=SystemSettings.js.map